import { useQuery } from '@hooks/reactQuery';

import { getOptionsKpi } from '@api/kpi';

import { extractQueryParams } from '@utils/common';

import { IOptionsKpiDto } from '@interfaces/kpi/dto/kpiDTO';

import { EUserRoles, TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';

interface IUseQueryOptionsKpiProps {
	isKpiView: boolean;
	vendor: TVendorsValues;
	queryKey: string;
	availableVendors: string[];
}

export const useQueryOptionsKpi = (props: IUseQueryOptionsKpiProps): {
	optionsKpi?: IOptionsKpiDto[];
	isLoadingOptionsKpi: boolean;
} => {
	const { isKpiView, vendor, queryKey, availableVendors } = props;
	const isEnabledByVendor = availableVendors.includes(vendor);

	const {
		data: optionsKpi,
		isInitialLoading: isLoadingOptionsKpi,
	} = useQuery({
		queryKey: [queryKey, vendor],
		queryFn: extractQueryParams(getOptionsKpi),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isEnabledByVendor],
		...refetchOptions,
	});

	return {
		optionsKpi,
		isLoadingOptionsKpi,
	};
};
